<template>
  <div class="landing-page">
    <AppHeader :interactive="false" />
    <main class="landing-content">
      <WelcomeText />
      <LandingMatchShowcase @showcase-games-loaded="updateShowcaseGames" />
      <div class="football-showcase">
        <div class="showcase-header">
          <p class="showcase-kicker">Browse By Match</p>
          <h2>Jump straight into the fixtures that matter most.</h2>
          <p class="showcase-copy">
            Explore match pages with AI-generated predictions, detailed odds, and team-by-team analysis.
          </p>
        </div>
        <FeaturedDisplay :excluded-ids="showcaseGameIds" />
      </div>
      <LeagueShowcase />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import WelcomeText from "@/components/WelcomeText.vue";
import LeagueShowcase from "@/components/LeagueShowcase.vue";
import LandingMatchShowcase from "@/components/LandingMatchShowcase.vue";
import FeaturedDisplay from "@/components/FeaturedDisplay.vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue"



export default {
  name: "LandingPage",
  data() {
    return {
      showcaseGameIds: [],
    };
  },
  components: {
    AppHeader,
    WelcomeText,
    LeagueShowcase,
    LandingMatchShowcase,
    FeaturedDisplay,
    AppFooter
    
  },
  methods: {
    updateShowcaseGames(ids) {
      this.showcaseGameIds = ids;
    },
  },
};
</script>

<style scoped>
.landing-page {
  background-color: white;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.landing-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 12px 0 24px;
}

.football-showcase {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.showcase-header {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto 18px;
  text-align: center;
}

.showcase-kicker {
  margin: 0 0 8px;
  color: #718294;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.showcase-header h2 {
  margin: 0;
  color: #142b48;
  font-size: clamp(1.3rem, 2.5vw, 2rem);
  line-height: 1.18;
}

.showcase-copy {
  margin: 10px 0 0;
  color: #5d7083;
}

@media (max-width: 700px) {
  .landing-content {
    gap: 18px;
    padding: 8px 0 16px;
  }
}

</style>
